var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-permission"},[_c('img',{attrs:{"src":require("@/static/images/null/empty.png"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm._f("getPermissionText")(_vm.$route.query.status)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }